module.exports = __webpack_public_path__ + "img/Lb_lambeth_logo.383a3811.svg";